export default "__VITE_ASSET__c7281d70__"